export const MARKETPLACE_SHIPPER_CONSTANTS_ERRORS = {
   NO_REQUESTS: 'No se pudo obtener las solicitudes',
   OFFER_SUCCESS_ACCEPTED: 'Se informará al transportista que has aceptado su solicitud',
   OFFER_SELECTED_ERROR: 'Ocurrió un error al actualizar los datos de la solicitud'
};
